common.View.create('shop::website.modules.shopCheckout.cart.Item', {

	onDOMLoad()
	{
		this.initAmountInput();
		this.initDeleteButton();
	},

	initDeleteButton()
	{
		// Listen for delete click.
		this.element
			.find('button[name="delete"]')
			.click(async () =>
			{
				// Abort due to unconfirmed?
				if (!(await Swal.fire({
					title: 'Zeker weten?',
					text: 'Weet u zeker dat u dit product wilt verwijderen?',
					icon: 'warning',
					showCancelButton: true,
					cancelButtonColor: '#707070',
					cancelButtonText: 'Nee, behoud',
					confirmButtonColor: '#6cba2c',
					confirmButtonText: 'Ja, verwijder'
				})).value)
					return;

				// Update
				await this.setDealAmount(0);
			});
	},

	initAmountInput()
	{
		//
		let timeout = null;

		// Listen for amount input change.
		this.element
			.find('input[name="amount"]')
			.on('input', async event =>
			{
				// No value due to user still typing?
				if ($(event.currentTarget).val() === '') {
				    // Cancel update when user still typing
                    clearTimeout(timeout);
					return;
				}

				// Cancel pending update?
				if (timeout) {
                    clearTimeout(timeout);
                }

				// Deffer updating.
				timeout = setTimeout(async () => this.setDealAmount($(event.currentTarget).val()), 1000)
			});
	},

	async setDealAmount(amount)
	{
		// Set as loading.
		let indexInstance = this.getIndexInstance();
		indexInstance.setLoading();

		// Set amount to 1 if user decides to enter negative number
		if (amount < 0) {
			amount = 1;
		}

		// Request
        let path = document.location.pathname;

		if( path.endsWith('/') ) {
		    path = path.slice(0, -1);
        }

		let response = await $.post(path + '/amount/' + this.element.data('product-variant-id'), {
			_method: 'PATCH',
			amount,
		});

		// Update amount in header.
		$('.website\\:\\:layouts-main-Header').data('instance')
			.setTotalPhysicalAmount(response.totalPhysicalAmount);

        // Update mini cart
        $('.shop\\:\\:website-modules-shopCheckout-cart-partials-MiniCart').data('instance')
            .replaceMiniCart(response.miniCartView, false);

		// Set new HTML in cart.
		indexInstance.setHtml(response.html);
	},

	getIndexInstance()
	{
		return shop.website.modules.shopCheckout.cart.Index.getInstance(this);
	}

});
